export default function (contentService, searchService) {

    /**
     * Uses contentService rather than searchService as results aren't weighted, just straight keyword/category matches 
     * @param {any} $q
     * @param {any} $timeout
     * @param {any} contentService
     */

    this.results = [];

    const q = {
        searchType: 'NewsSearcher',
        contentTypes: ['NewsItem', 'longRead'],
        fields: ['summary', 'newsDate', 'createDate'],
        count: 12
    };

    this.clear = () => this.results = [];

    this.filter = () => {
        this.clear();
        this.isBrowse = true;

        q.query = {
            category: this.category
        }

        const now = new Date();
        //ticks are recorded from 1/1/1; get microtime difference from 1/1/1/ to 1/1/1970
        const epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));

        contentService.get(q)
            .then(result => {
                result.forEach(r => {
                    //ticks are in nanotime; convert to microtime
                    var ticksToMicrotime = (r.newsDate || r.createDate) / 10000;                    

                    //new date is ticks, converted to microtime, minus difference from epoch microtime
                    const date = new Date(ticksToMicrotime - epochMicrotimeDiff);

                    r.date = date.getFullYear() === now.getFullYear() ?
                        date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }) :
                        date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
                })

                this.results = result.sort((a, b) => a.date > b.date);
            });
    }

    this.search = () => {
        this.clear();
        this.isBrowse = false;

        searchService.getSearchResults(this.keyword, 'news', 1, 12)
            .then(resp => this.results = resp.results.sort((a, b) => a.updated > b.updated));
    }

    // pass a querystring ?q=filter to search on filter
    if (window.location.search) {
        const params = new URLSearchParams(window.location.search);
        const query = params.get('q');

        if (query) {
            this.keyword = query.split(',')[0];
            this.search();
        }
    }
}